module.exports = __webpack_public_path__ + "img/hxjz.b4cd73d1.jpg";